import { BaseFilters } from '@/models/Service';
import requester from '@/lib/axios';
import Enrollment, { EnrollmentStatusEnum } from '@/models/Enrollment';
import JsonApiResponse from '@/models/JsonApiResponse';

export interface EnrollmentFiltersParams {
  pageSize?: number;
  pageNumber?: number;
  status?: EnrollmentStatusEnum[];
  coursePathSlug?: string;
}

export const listEnrollmentsByStudent = async (
  studentId: number,
  params: EnrollmentFiltersParams,
) => {
  const { data } = await requester().get<JsonApiResponse<Enrollment>>(
    `students/${studentId}/enrollment/`,
    {
      params,
    },
  );
  return data;
};

export interface ListEnrollmentsFilters extends BaseFilters {
  klassId?: number;
  status?: EnrollmentStatusEnum[];
}

export const listEnrollments = async (params: ListEnrollmentsFilters = {}) => {
  const { data } = await requester().get<JsonApiResponse<Enrollment>>(
    'students/enrollments/',
    {
      params,
    },
  );
  return data;
};

type GetEnrollmentParams = {
  studentId: number;
  enrollmentId: number;
};

type ActivateEnrollmentPayload = {
  activatedAt: string;
};

export const activateEnrollment = async (
  { enrollmentId, studentId }: GetEnrollmentParams,
  body: ActivateEnrollmentPayload,
) => {
  await requester().patch(
    `students/${studentId}/enrollment/${enrollmentId}/activate/`,
    body,
  );
};
